import { MenuItem } from "@material-ui/core";
import { makeStyles, Paper } from "@material-ui/core";
import React, { useMemo } from "react";
import { connect } from "react-redux";
import DashboardListItem from "./DashboardListItem";
import DashboardTitle from "./DashboardTitle";

// Map factor names to icon names
const FACTOR_ICON_MAP = {
  'Academics': 'School',
  'Athletics': 'Sports',
  'Social': 'People',
  'Mental Health': 'Psychology',
  'Physical Health': 'Favorite',
  'Financial': 'AttachMoney',
  'Family': 'FamilyRestroom',
  'Relationships': 'Group',
  'Career': 'Work',
  'Other': 'MoreHoriz'
};

// Default icon if no match found
const DEFAULT_ICON = 'Circle';

// Helper function to get icon for a factor
const getFactorIcon = (factorName) => {
  if (!factorName) return DEFAULT_ICON;
  const matchedKey = Object.keys(FACTOR_ICON_MAP).find(key => 
    factorName.toLowerCase().includes(key.toLowerCase())
  );
  return matchedKey ? FACTOR_ICON_MAP[matchedKey] : DEFAULT_ICON;
};

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#16192B",
    padding: 10,
    borderRadius: 8,
    width: "100%",
  },
  menuItem: {
    padding: "4px 0",
    width: "100%",
  },
}));

const DashboardCardList = ({ contributing_factors = [] }) => {
  const classes = useStyles();

  // Process factors: sort by position, take top 5, ensure icons
  const topFactors = useMemo(() => {
    return [...contributing_factors]
      .sort((a, b) => (a.position || 0) - (b.position || 0)) // Sort by position
      .slice(0, 5) // Take top 5
      .map(factor => ({
        ...factor,
        // Ensure icon is set, use mapping if not provided
        icon: factor.icon || getFactorIcon(factor.name)
      }));
  }, [contributing_factors]);

  return (
    <Paper className={classes.container}>
      <div className="mb-5">
        <DashboardTitle
          variant="blue-green"
          fontWeight={500}
          fontSize={20}
          text="Contributing Factors"
        />
      </div>
      {topFactors.length > 0 ? (
        topFactors.map((factor) => (
          <MenuItem key={factor.position} className={classes.menuItem}>
            <DashboardListItem
              text={factor.name}
              percent={factor.value}
              icon={factor.icon}
              isSelected={factor.position === 1}
            />
          </MenuItem>
        ))
      ) : (
        <div className={classes.menuItem}>
          <DashboardTitle
            variant="grey3"
            fontWeight={400}
            fontSize={14}
            text="No contributing factors data available"
          />
        </div>
      )}
    </Paper>
  );
};

const mapStateToProps = (store) => ({
  contributing_factors:
    store.dashboard.data.dashboard_data.contributing_factors,
});

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardCardList);
